import { withStyles, Theme } from '@material-ui/core/styles';

// Contants
import PATHS from 'constants/publicPaths';

const { pathname } = window.location;
const showAtendentContainer = !PATHS.find((path) => path === pathname);

const GlobalCss = withStyles((theme: Theme) => ({
  '@global': {
    body: {
      background: '#fff',
      '& > div.MuiDrawer-root.MuiDrawer-modal': {
        '&:not(:root):fullscreen::backdrop': {
          position: 'fixed',
          inset: 0,
          background: 'transparent',
        },
      },
    },
    '.MuiDialog-paperScrollPaper': {
      padding: '0.5rem',
    },
    '.MuiDialogContent-root': {
      overflow: 'auto !important',
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#2093a2',
        borderRadius: 15,
      },
      scrollbarWidth: 'thin', // Firefox suport
      msOverflowStyle: 'auto', // IE10+ Support
    },
    '.MuiDialog-paperWidthSm': {
      borderRadius: '0.75rem !important',
    },
    '.MuiPaper-rounded': {
      borderRadius: '1rem !important',
    },
    '.MuiDialog-paper': {
      margin: '2rem !important',
    },
    '#menu- > div.MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded': {
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#2093a2',
        borderRadius: 16,
      },
      scrollbarWidth: 'thin', // Firefox suport
      msOverflowStyle: 'auto', // IE10+ Support
    },
    // '.makeStyles-root-1': {
    //   background: '#222B2E !important',
    //   opacity: 0.9,
    // },

    '.rcw-widget-container': {
      display: showAtendentContainer ? 'flex' : 'none',
    },

    [theme.breakpoints.down(1081)]: {
      html: {
        fontSize: '92%',
      },
    },
    [theme.breakpoints.down(721)]: {
      html: {
        fontSize: '84%',
      },
    },
    [theme.breakpoints.down(501)]: {
      html: {
        fontSize: '76%',
      },
    },
    [theme.breakpoints.down(401)]: {
      html: {
        fontSize: '68%',
      },
    },
  },
}))(() => null);

export default GlobalCss;
